import React from 'react';
import { Container, Divider } from '../design-system';
import { Mail } from 'lucide-react';
import { useI18n } from '../i18n/I18nProvider';
import { trackEvent } from '../utils/analytics';

export function Footer() {
  const { t } = useI18n();
  const footerLinks = {
    services: [
      { label: t('services.items.web.title'), href: '#services' },
      { label: t('services.items.mobile.title'), href: '#services' },
      { label: t('services.items.backend.title'), href: '#services' },
      { label: t('services.items.consulting.title'), href: '#services' }
    ],
    resources: [
      { label: t('nav.faq'), href: '#faq' }
    ]
  };

  

  return (
    <footer className="bg-slate-900 text-white pt-16 pb-8">
      <Container maxWidth="xl">
        <div className="grid md:grid-cols-2 lg:grid-cols-5 gap-12 mb-12">
          <div className="lg:col-span-2">
            <img
              src="/images/logo.png"
              alt="Gruty"
              className="h-12 w-auto"
              decoding="async"
              loading="lazy"
            />
            <p className="mt-4 text-slate-400 max-w-md">
              {t('footer.description.line1')} 
              {t('footer.description.line2')}
            </p>
            
            <div className="mt-6 space-y-3">
              <div className="flex items-center gap-3 text-slate-400">
                <Mail className="w-5 h-5" />
                <a
                  href="mailto:gruty@gruty.dev"
                  className="hover:text-white transition-colors"
                  onClick={() => trackEvent('email_click', { location: 'footer' })}
                >
                  gruty@gruty.dev
                </a>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Serviços</h3>
            <ul className="space-y-3">
              {footerLinks.services.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Recursos</h3>
            <ul className="space-y-3">
              {footerLinks.resources.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-slate-400 hover:text-white transition-colors"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Divider className="bg-slate-800 my-8" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-400 text-sm">
            {t('footer.copyright')}
          </p>

          
        </div>
      </Container>
    </footer>
  );
}
